import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslation from 'app/translations/translation.en-US.json'
import fiTranslation from 'app/translations/translation.fi-FI.json'
import svTranslation from 'app/translations/translation.sv-SE.json'

const resources = {
  en: {
    translation: enTranslation
  },
  fi: {
    translation: fiTranslation
  },
  sv: {
    translation: svTranslation
  }
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'fi-FI',
  lng: 'fi-FI',
  interpolation: {
    escapeValue: false
  }
})

export const initTranslation = (lang = 'fi-FI'): void => {
  i18n.use(initReactI18next).init({
    resources,
    fallbackLng: 'fi-FI',
    lng: lang,
    interpolation: {
      escapeValue: false
    }
  })
}
